console.log('process.env',process.env)
const serverList = [
  {
    BASEURL: 'http://localhost:8991/',
  },
  {
    BASEURL: 'https://cps.tao648.cn/api',
  }
];
let serverArr = serverList[1]
export default serverArr
